<template>
  <div class="container">
    <div class="row">
      <div class="col col-1 pull-left">
        <router-link :to="getBackUrl()" v-if="submitted === false">
          <button class="btn">
            <icon :icon="['fad', 'door-open']"/>
            Back
          </button>
        </router-link>
      </div>
      <div class="col col-8">
        <h2 class="text-center">Contact the Presenter</h2>
        <form id="contact_form" @submit.prevent="submitForm()" v-if="submitted === false">
          <div class="form-group">
            <label for="name">Your name:*</label>
            <input v-model="name" class="form-control" id="name" name="name" required type="text"/>
          </div>
          <div class="form-group">
            <label for="email">Your email:*</label>
            <input v-model="email" class="form-control" id="email" name="email" required type="email"/>
          </div>
          <div class="form-group">
            <label for="message">Message:*
              <small>(<span>{{ message.length }}</span> / <span>{{ maxLength }}</span>)</small>
            </label>
            <textarea v-model="message" class="form-control" name="message" id="message" required
                      :maxlength="maxLength"></textarea>
          </div>
          <div class="form-group">
            <input class="" id="datasecurity" name="datasecurity" required type="checkbox"/> I accept the Data Security
            Agreement (<a href="https://www.abstractstosubmit.com/datenschutz/eposter_wall/data_security_agreement.html"
                          target="_blank">Click here to see the complete Data Security Agreement.</a>)
          </div>
          <button type="submit" class="btn btn-primary float-right ml-1">
            <icon :icon="['fad', 'paper-plane']" v-on:submit="sendMail()"/>
            Send
          </button>
          <div class="row alert border-info">
            <div class="col col-1">
              <icon :icon="['fad', 'info']" class="fa-2x"/>
            </div>
            <div class="col col-10 offset-1 my-auto">All data entered will be transmitted to the presenter by
              e-mail.<br>You will receive a copy.
            </div>
          </div>
        </form>

        <div v-if="submitted === true">
          <div class="row alert alert-success">
            <div class="col col-1">
              <icon :icon="['fad', 'check-circle']" class="fa-5x"/>
            </div>
            <div class="col col-8 offset-1 my-auto">Your e-mail has been sent to the presenter.<br> We can not guarantee
              that
              this e-mail
              will
              be delivered or read.
            </div>
          </div>
          <router-link :to="getBackUrl()">
            <button class="btn btn-primary float-right">
              <icon :icon="['fad', 'door-open']"/>
              Back
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        name: "Mail",
        data: function () {
            return {
                submitted: false,
                name: '',   // data for the name on the form
                email: '',   // data for the email on the form
                message: '', // data for the message on the form
                maxLength: 2500, // maximum length of the form message
                posterID: this.$route.params.id,
                errorMessage: ''// message to show the user if there is an error
            }
        },
        methods: {
            genericMessage() {
                return '<h4>Contact message from the '+process.env.VUE_APP_PATH_SYSTEM+'</h4>' +
                    '<div>This message relays to this poster: <a href="'+process.env.VUE_APP_PATH_SYSTEM+'#/viewer/"' + this.$route.params.id + '">'+process.env.VUE_APP_PATH_SYSTEM+'#/viewer/' + this.$route.params.id + '</a></div>';
            },
            getBackUrl() {
                return '/view/' + this.$route.params.id;
            },
            submitForm() {
                let mail = {
                    'abstract_id': this.$route.params.id,
                    'name': this.name,
                    'email': this.email,
                    'message': this.message,
                    'generic_message': this.genericMessage()
                };
                this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'mail/contact', this.$route.params.id);
                this.$store.dispatch('SEND_MAIL_CONTACT', mail);
                this.submitted = true;
            }
        },
    }
</script>

<style scoped>

</style>
